import { FunctionComponent } from 'react';

import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetNews } from '~components/hooks';
import { PostItem } from './';

export const RightNewCases: FunctionComponent = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const getNewCases = useGetNews(
    {
      where: {
        tags: { some: { name: { equals: 'case' } } },
        status: { equals: 'published' },
        language: { equals: language },
      },
      orderBy: [{ publishDate: 'desc' }],
      take: 4,
    },
    'getNewCases',
  );

  return (
    <div className="news-sidebar-item-wrap">
      <div className="news-sidebar-item-title">
        {t('news-sidebar-item-title new-case')}
      </div>
      {_.map(getNewCases?.data?.posts, getNews => (
        <PostItem key={getNews.id} getNews={getNews} />
      ))}

      <Link to="/blog/tag/case" className="news-sidebar-item-more">
        {t('news-sidebar-item-more')}
        <span className="icon">
          <svg
            width="8"
            height="13"
            viewBox="0 0 8 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.83928 6.5L-0.000117354 1.66053L1.15981 0.5L7.15918 6.49947L5.99921 7.66L1.15981 12.5L-0.000117777 11.3395L4.83928 6.5Z"
              fill="#FFD800"
            ></path>
          </svg>
        </span>
      </Link>
    </div>
  );
};
